import {
    BriefStore,
    StatisticsStore,
    SimpleStore,
    MIXPANEL_EVENT_PROPERTIES,
    UserStore,
} from '../../../shared/mixpanel';

export default {
    brief: new BriefStore(),

    statistics: new StatisticsStore(),

    listingsType: new SimpleStore<
        MIXPANEL_EVENT_PROPERTIES.LISTINGS_TYPE,
        string
    >(MIXPANEL_EVENT_PROPERTIES.LISTINGS_TYPE),

    sourcePage: new SimpleStore<MIXPANEL_EVENT_PROPERTIES.SOURCE_PAGE, string>(
        MIXPANEL_EVENT_PROPERTIES.SOURCE_PAGE,
        {
            disableErrorLogging: true,
        }
    ),

    searchQuery: new SimpleStore<
        MIXPANEL_EVENT_PROPERTIES.SEARCH_QUERY,
        string
    >(MIXPANEL_EVENT_PROPERTIES.SEARCH_QUERY, {
        disableErrorLogging: true,
    }),

    position: new SimpleStore<MIXPANEL_EVENT_PROPERTIES.POSITION, number>(
        MIXPANEL_EVENT_PROPERTIES.POSITION
    ),

    page: new SimpleStore<MIXPANEL_EVENT_PROPERTIES.PAGE, string>(
        MIXPANEL_EVENT_PROPERTIES.PAGE
    ),

    user: new UserStore(),
};
